// extracted by mini-css-extract-plugin
export var cardContainer = "_o0-0";
export var cardHeader = "_o0-2";
export var collapsedState = "_o0-3";
export var dragHandle = "_o0-5";
export var dragHandleIcon = "_o0-6";
export var dragging = "_o0-1";
export var titleArea = "_o0-4";